import { UploadedFile } from '../use-user-upload/use-user-upload.types';

interface FileTypeConfig {
  mimeType: string;
  icon?: string;
  sizeLimit: number;
}

const docTypes: Record<string, FileTypeConfig> = {
  '.pdf': {
    mimeType: 'application/pdf',
    icon: '/app/static/images/icons/pdf.svg',
    sizeLimit: 7 * 1024 * 1024,
  },
  '.txt': {
    mimeType: 'text/plain',
    icon: '/app/static/images/icons/txt.svg',
    sizeLimit: 2 * 1024 * 1024,
  },
  '.csv': {
    mimeType: 'text/csv',
    icon: '/app/static/images/icons/csv.svg',
    sizeLimit: 2 * 1024 * 1024,
  },
};

export const imageTypes: Record<string, FileTypeConfig> = {
  '.png': {
    mimeType: 'image/png',
    icon: '/app/static/images/icons/png.svg',
    sizeLimit: 5 * 1024 * 1024,
  },
  '.jpeg': {
    mimeType: 'image/jpeg',
    icon: '/app/static/images/icons/jpg.svg',
    sizeLimit: 5 * 1024 * 1024,
  },
  '.jpg': {
    mimeType: 'image/jpeg',
    icon: '/app/static/images/icons/jpg.svg',
    sizeLimit: 5 * 1024 * 1024,
  },
};

export const allowedFileTypes: Record<string, FileTypeConfig> = {
  ...docTypes,
  ...imageTypes,
};

export const allowedTypesMimeType: string[] = [
  ...new Set(Object.values(allowedFileTypes).map(f => f.mimeType)),
];

export const allowedTypesExtension = Object.keys(allowedFileTypes).join(',');

const DEFAULT_SIZE_LIMIT = 7 * 1024 * 1024;

export const getMaxFileSize = (mimeType: string): number => {
  const fileTypeEntry = Object.values(allowedFileTypes).find(
    config => config.mimeType === mimeType
  );
  return fileTypeEntry?.sizeLimit || DEFAULT_SIZE_LIMIT;
};

export const formatUploadFiles = (files: File[]): UploadedFile[] => {
  const selectedFiles = Array.from(files);

  return selectedFiles.map(i => {
    const thumbnailUrl = i.type.startsWith('image/')
      ? URL.createObjectURL(i)
      : undefined;

    return {
      field_name: crypto.randomUUID(),
      fileType: i.type,
      status: 'uploading',
      fileData: i,
      name: i.name,
      sizeInBytes: i.size,
      thumbnailUrl,
    };
  });
};
